import { render, staticRenderFns } from "./index.vue?vue&type=template&id=790b5e27&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=790b5e27&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790b5e27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790b5e27')) {
      api.createRecord('790b5e27', component.options)
    } else {
      api.reload('790b5e27', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=790b5e27&scoped=true", function () {
      api.rerender('790b5e27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/home/adviser/index.vue"
export default component.exports